import { activityFetch as fetch } from '../../components/feedback/requestActivity'
import { titleTheme, pageTheme, headerTheme, contentTheme, subTheme, cardTheme } from '../../components/consoleTheme'
import NodeSetupGuide from '../../components/NodeSetupGuide'

import { useState, useEffect } from "react"
import styled from "styled-components"
import {
  Plus, RefreshCw, Trash2, HardDrive, Server, KeyRound, FolderPlus, Copy,
  Cloud, Network, Settings, ChevronRight, Database, X, BookOpen,
} from "lucide-react"

const API = "/api/storage"
function getToken() { return sessionStorage.getItem("token") || localStorage.getItem("token") }
function authHeaders(json = true) {
  const h = {}
  if (json) h["Content-Type"] = "application/json"
  const t = getToken()
  if (t) h["Authorization"] = `Bearer ${t}`
  return h
}
function copyText(t) {
  if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(t).catch(() => fb(t)); else fb(t)
}
function fb(t) { const a = document.createElement("textarea"); a.value = t; a.style.position = "fixed"; a.style.opacity = "0"; document.body.appendChild(a); a.select(); try { document.execCommand("copy") } catch (_) {} document.body.removeChild(a) }
function fmtBytes(n) { if (!n) return "-"; const u = ["B", "KB", "MB", "GB", "TB", "PB"]; let i = 0, v = Number(n); while (v >= 1024 && i < u.length - 1) { v /= 1024; i++ } return `${v.toFixed(v < 10 && i > 0 ? 1 : 0)} ${u[i]}` }

const Page = styled.div`
  ${pageTheme}
padding:0; background:#f8fafc; min-height:100vh;`
const Header = styled.header`
  ${headerTheme}
display:flex; align-items:center; justify-content:space-between; padding:1rem 2rem; background:#fff; border-bottom:1px solid #e2e8f0;@media(max-width:768px){padding:1rem;flex-wrap:wrap;gap:.75rem;}`
const Title = styled.h1`
 ${titleTheme}
font-size:1.25rem; font-weight:600; color:#1e293b;`
const Sub = styled.p`
  ${subTheme}
margin:.25rem 0 0; font-size:.8rem; color:#94a3b8;`
const Button = styled.button`
  display:inline-flex; align-items:center; gap:.5rem; padding:.5rem 1rem; border-radius:.375rem; font-weight:500; cursor:pointer;
  ${(p) => p.primary ? `background:var(--accent);color:#fff;border:none;&:hover{background:#115855;}` : `background:#fff;color:#64748b;border:1px solid #e2e8f0;&:hover{background:#f8fafc;}`}
  &:disabled{opacity:.5;cursor:default;}`
const Content = styled.div`
  ${contentTheme}
padding:2rem;@media(max-width:768px){padding:1rem;}`
const Card = styled.div`
  ${cardTheme}
background:#fff; border:1px solid #e2e8f0; border-radius:.5rem; overflow:hidden; margin-bottom:1.5rem;`
const CardHead = styled.div`padding:.85rem 1.5rem; border-bottom:1px solid #f1f5f9; font-weight:600; color:#334155; display:flex; align-items:center; justify-content:space-between; gap:.5rem; > span{display:flex;align-items:center;gap:.5rem;}@media(max-width:768px){padding:1rem;flex-wrap:wrap;>span{min-width:0;overflow-wrap:anywhere;}}`
const Empty = styled.div`padding:1.6rem; text-align:center; color:#94a3b8; font-size:.88rem;`
const Mono = styled.code`font-family:ui-monospace,Menlo,Consolas,monospace; font-size:.8rem; color:#334155;`
const TabBar = styled.div`overflow-y:hidden;display:flex; gap:.25rem; border-bottom:1px solid #e2e8f0; margin-bottom:1.5rem;overflow-x:auto;max-width:100%;-webkit-overflow-scrolling:touch;`
const TabBtn = styled.button`display:inline-flex; align-items:center; gap:.4rem; padding:.6rem 1rem; background:none; border:none; cursor:pointer; font-size:.9rem; font-weight:${(p) => (p.active ? 600 : 500)}; color:${(p) => (p.active ? "var(--accent)" : "#64748b")}; border-bottom:2px solid ${(p) => (p.active ? "var(--accent)" : "transparent")}; margin-bottom:-1px; &:hover{color:var(--accent);}`
const Row = styled.div`display:grid; grid-template-columns:${(p) => p.cols || "auto"}; gap:.5rem; align-items:center; padding:.7rem 1.5rem; border-bottom:1px solid #f1f5f9; font-size:.86rem; &:last-child{border-bottom:none;}@media(max-width:768px){grid-template-columns:minmax(0,1fr) minmax(0,1fr);padding:1rem;gap:.65rem;border-bottom:8px solid #f8fafc;>*{min-width:0;overflow-wrap:anywhere;}>:first-child,>:last-child{grid-column:1/-1;}}`
const IconBtn = styled.button`background:none; border:1px solid #e2e8f0; border-radius:6px; padding:4px 8px; cursor:pointer; color:#64748b; display:inline-flex; align-items:center; gap:4px; font-size:.78rem; &:hover{color:var(--accent);border-color:var(--accent);}`
const Input = styled.input`padding:.5rem .7rem; border:1px solid #e2e8f0; border-radius:6px; outline:none; font-size:.85rem; &:focus{border-color:var(--accent);}`
const Select = styled.select`padding:.5rem .7rem; border:1px solid #e2e8f0; border-radius:6px; outline:none; font-size:.85rem; background:#fff;`
const Form = styled.div`display:flex; flex-wrap:wrap; gap:.5rem; padding:1rem 1.5rem; border-bottom:1px solid #f1f5f9; align-items:center;@media(max-width:768px){padding:1rem;flex-direction:column;align-items:stretch;>*{width:100%;}}`
const Dot = styled.span`display:inline-block; width:8px; height:8px; border-radius:50%; margin-right:6px; background:${(p) => p.s === "ok" ? "#22c55e" : p.s === "fail" ? "#ef4444" : "#cbd5e1"};`
const Note = styled.div`display:flex; gap:.6rem; padding:.85rem 1rem; border-radius:8px; font-size:.84rem; line-height:1.55; background:#eff6ff; border:1px solid #bfdbfe; color:#1e40af; margin-bottom:1.25rem;`
const Cmd = styled.div`display:flex; align-items:center; justify-content:space-between; gap:.75rem; background:#0f172a; color:#e2e8f0; border-radius:6px; padding:.6rem .85rem; margin:.35rem 0; font-family:ui-monospace,Menlo,Consolas,monospace; font-size:.8rem; overflow-x:auto; button{background:none;border:none;color:#94a3b8;cursor:pointer;flex-shrink:0;&:hover{color:#fff;}}`

/* ── 온프레 네트워크 드라이브 ── */
function OnPremPanel() {
  const [nodes, setNodes] = useState([])
  const [sel, setSel] = useState(null)
  const [blocks, setBlocks] = useState([])
  const [shares, setShares] = useState([])
  const [busy, setBusy] = useState("")
  const [adding, setAdding] = useState(false)
  const [form, setForm] = useState({ name: "", address: "", ssh_user: "root", ssh_port: "22", secret_type: "key", ssh_secret: "" })
  const [shareForm, setShareForm] = useState({ share_name: "", path: "" })
  const [shareResult, setShareResult] = useState(null)

  const loadNodes = async () => {
    try { const d = await fetch(`${API}/nodes`, { headers: authHeaders(false), credentials: "include" }).then(x => x.json()); setNodes(d.nodes || []) } catch (_) {}
  }
  useEffect(() => { loadNodes() }, [])

  const openNode = async (n) => {
    setSel(n); setBlocks([]); setShares([]); setShareResult(null)
    try {
      const [b, s] = await Promise.all([
        fetch(`${API}/nodes/${n.node_id}/blocks`, { headers: authHeaders(false), credentials: "include" }).then(x => x.json()),
        fetch(`${API}/nodes/${n.node_id}/shares`, { headers: authHeaders(false), credentials: "include" }).then(x => x.json()),
      ])
      setBlocks(b.devices || []); setShares(s.shares || [])
    } catch (_) {}
  }

  const addNode = async () => {
    if (!form.name || !form.address) { alert("이름·주소 필수"); return }
    setBusy("add")
    try {
      const res = await fetch(`${API}/nodes`, { method: "POST", headers: authHeaders(), credentials: "include", body: JSON.stringify(form) })
      const d = await res.json().catch(() => ({}))
      if (!res.ok) { alert("등록 실패: " + (d.error || res.status)); return }
      if (d.test && !d.test.ok) alert("등록은 됐지만 SSH 연결 테스트 실패:\n" + d.test.error)
      setForm({ name: "", address: "", ssh_user: "root", ssh_port: "22", secret_type: "key", ssh_secret: "" }); setAdding(false); loadNodes()
    } finally { setBusy("") }
  }
  const testNode = async (id) => { setBusy("t" + id); try { const r = await fetch(`${API}/nodes/${id}/test`, { method: "POST", headers: authHeaders(false), credentials: "include" }).then(x => x.json()); if (!r.ok) alert("연결 실패:\n" + (r.error || "")); loadNodes() } finally { setBusy("") } }
  const setCred = async (n) => { const s = window.prompt(`${n.name} SSH ${n.secret_type === "password" ? "비밀번호" : "개인키(전체)"} 입력:`); if (s == null) return; await fetch(`${API}/nodes/${n.node_id}`, { method: "PUT", headers: authHeaders(), credentials: "include", body: JSON.stringify({ ssh_secret: s }) }); loadNodes() }
  const delNode = async (id) => { if (!window.confirm("노드를 삭제할까요?")) return; await fetch(`${API}/nodes/${id}`, { method: "DELETE", headers: authHeaders(false), credentials: "include" }); if (sel?.node_id === id) setSel(null); loadNodes() }

  const createShare = async () => {
    if (!shareForm.share_name || !shareForm.path) { alert("공유이름·경로 필수"); return }
    setBusy("share")
    try {
      const res = await fetch(`${API}/nodes/${sel.node_id}/shares`, { method: "POST", headers: authHeaders(), credentials: "include", body: JSON.stringify(shareForm) })
      const d = await res.json().catch(() => ({}))
      if (!res.ok) { alert("공유 생성 실패:\n" + (d.error || res.status)); return }
      setShareResult(d); setShareForm({ share_name: "", path: "" }); openNode(sel); loadNodes()
    } finally { setBusy("") }
  }
  const delShare = async (sid) => { if (!window.confirm("공유를 삭제할까요?")) return; await fetch(`${API}/nodes/${sel.node_id}/shares/${sid}`, { method: "DELETE", headers: authHeaders(false), credentials: "include" }); openNode(sel); loadNodes() }

  const flatBlocks = []
  const walk = (d, depth) => { d.forEach((x) => { flatBlocks.push({ ...x, depth }); if (x.children) walk(x.children, depth + 1) }) }
  walk(blocks, 0)

  return (
    <>
      <Note>
        <Network size={18} style={{ flexShrink: 0 }} />
        <span>온프레 박스에 <strong>SkynetMesh 에이전트(VPC)</strong>를 설치해 가상IP로 연결하고, 여기에 <strong>SSH 노드</strong>로 등록하면
          디스크를 골라 <strong>Samba 네트워크 드라이브</strong>로 공유합니다. 내 PC(같은 VPC)에서 <Mono>net use</Mono>로 마운트.</span>
      </Note>

      <Card>
        <CardHead>
          <span><Server size={16} /> 스토리지 노드 ({nodes.length})</span>
          <IconBtn onClick={() => setAdding(v => !v)}><Plus size={13} /> 노드 추가</IconBtn>
        </CardHead>
        {adding && (
          <Form>
            <Input placeholder="이름" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
            <Input placeholder="가상IP/주소" value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} />
            <Input placeholder="SSH 계정" value={form.ssh_user} onChange={e => setForm({ ...form, ssh_user: e.target.value })} style={{ width: 110 }} />
            <Input placeholder="포트" value={form.ssh_port} onChange={e => setForm({ ...form, ssh_port: e.target.value })} style={{ width: 70 }} />
            <Select value={form.secret_type} onChange={e => setForm({ ...form, secret_type: e.target.value })}><option value="key">개인키</option><option value="password">비밀번호</option></Select>
            <Input placeholder={form.secret_type === "password" ? "비밀번호" : "개인키(전체 붙여넣기)"} type={form.secret_type === "password" ? "password" : "text"} value={form.ssh_secret} onChange={e => setForm({ ...form, ssh_secret: e.target.value })} style={{ flex: 1, minWidth: 160 }} />
            <Button primary onClick={addNode} disabled={busy === "add"}>{busy === "add" ? "테스트·등록 중…" : "연결 후 등록"}</Button>
          </Form>
        )}
        {nodes.length === 0 ? <Empty>등록된 노드가 없습니다.</Empty> : nodes.map(n => (
          <Row key={n.node_id} cols="1.3fr 1.5fr 1fr .9fr auto">
            <span style={{ fontWeight: 600, color: "#1e293b", display: "flex", alignItems: "center", gap: 6 }}><HardDrive size={15} color="#64748b" /> {n.name}</span>
            <Mono>{n.ssh_user}@{n.address}:{n.ssh_port}</Mono>
            <span style={{ color: "#475569" }} title={n.last_error || ""}><Dot s={n.last_status} />{n.last_status === "ok" ? "연결됨" : n.last_status === "fail" ? "실패" : "미확인"}{!n.has_secret && " · 자격없음"}</span>
            <span style={{ color: "#64748b", fontSize: ".82rem" }}>공유 {n.share_count}</span>
            <span style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
              <IconBtn onClick={() => openNode(n)} title="관리"><Settings size={13} /> 관리</IconBtn>
              <IconBtn onClick={() => setCred(n)} title="SSH 자격"><KeyRound size={13} /></IconBtn>
              <IconBtn onClick={() => testNode(n.node_id)} disabled={busy === "t" + n.node_id}>{busy === "t" + n.node_id ? "…" : "테스트"}</IconBtn>
              <IconBtn style={{ borderColor: "#fecaca", color: "#ef4444" }} onClick={() => delNode(n.node_id)}><Trash2 size={13} /></IconBtn>
            </span>
          </Row>
        ))}
      </Card>

      {sel && (
        <Card>
          <CardHead>
            <span><Settings size={16} /> {sel.name} — 디스크 & 공유</span>
            <IconBtn onClick={() => setSel(null)}><X size={13} /> 닫기</IconBtn>
          </CardHead>

          <div style={{ padding: "1rem 1.5rem" }}>
            <div style={{ fontWeight: 600, color: "#475569", fontSize: ".85rem", marginBottom: ".5rem" }}>
              디스크 {sel.os_type === "windows" ? "(Windows)" : "(lsblk)"}
              {sel.os_type && <span style={{ marginLeft: 8, fontSize: ".72rem", padding: "1px 7px", borderRadius: 10, background: sel.os_type === "windows" ? "#dbeafe" : "#dcfce7", color: sel.os_type === "windows" ? "#1d4ed8" : "#15803d" }}>{sel.os_type}</span>}
            </div>
            {flatBlocks.length === 0 ? (
              <Empty style={{ padding: ".8rem" }}>
                디스크 정보를 못 읽었습니다 (SSH 자격/연결 확인).
                {sel.last_status !== "ok" && (
                  <div style={{ marginTop: ".5rem", fontSize: ".8rem", color: "#64748b" }}>
                    Windows PC라면 호스트에서 관리자 PowerShell로 한 번 실행해 SSH를 켜세요:
                    <Mono style={{ display: "block", marginTop: 4, color: "#0f172a" }}>irm https://skynet.re.kr/download/storage-host.ps1 | iex</Mono>
                    이후 [테스트] → [관리] 하면 디스크가 보입니다.
                  </div>
                )}
              </Empty>
            ) : (
              <div style={{ border: "1px solid #f1f5f9", borderRadius: 8, overflow: "hidden" }}>
                <Row cols="2fr .8fr .8fr 1fr 1.2fr" style={{ background: "#f8fafc", fontWeight: 600, color: "#64748b", fontSize: ".8rem" }}>
                  <span>이름</span><span>크기</span><span>타입</span><span>파일시스템</span><span>마운트</span>
                </Row>
                {flatBlocks.map((b, i) => (
                  <Row key={i} cols="2fr .8fr .8fr 1fr 1.2fr">
                    <Mono style={{ paddingLeft: b.depth * 14 }}>{b.depth > 0 ? "└ " : ""}{b.name}{b.model ? ` (${b.model.trim()})` : ""}</Mono>
                    <span style={{ fontSize: ".82rem" }}>{fmtBytes(b.size)}</span>
                    <span style={{ fontSize: ".82rem", color: "#64748b" }}>{b.type}</span>
                    <span style={{ fontSize: ".82rem", color: "#64748b" }}>{b.fstype || "-"}</span>
                    <Mono style={{ color: b.mountpoint ? "#16a34a" : "#cbd5e1" }}>{b.mountpoint || "-"}</Mono>
                  </Row>
                ))}
              </div>
            )}

            <div style={{ fontWeight: 600, color: "#475569", fontSize: ".85rem", margin: "1.2rem 0 .5rem" }}>네트워크 드라이브 공유</div>
            <div style={{ display: "flex", gap: ".5rem", flexWrap: "wrap", alignItems: "center", marginBottom: ".7rem" }}>
              <Input placeholder="공유 이름 (예: data)" value={shareForm.share_name} onChange={e => setShareForm({ ...shareForm, share_name: e.target.value })} style={{ width: 180 }} />
              <Input placeholder={sel.os_type === "windows" ? "공유할 경로 (예: C:\\data)" : "공유할 경로 (예: /mnt/disk1)"} value={shareForm.path} onChange={e => setShareForm({ ...shareForm, path: e.target.value })} style={{ flex: 1, minWidth: 200 }} />
              <Button primary onClick={createShare} disabled={busy === "share"}><FolderPlus size={15} /> {busy === "share" ? "구성 중…" : "공유 만들기"}</Button>
            </div>

            {shareResult && (
              <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 8, padding: "1rem", marginBottom: ".7rem" }}>
                <div style={{ fontWeight: 600, color: "#166534", marginBottom: ".4rem" }}>공유 생성됨 — 내 PC에서 연결</div>
                <div style={{ fontSize: ".82rem", color: "#475569", marginBottom: ".3rem" }}>Windows (탐색기 네트워크 드라이브):</div>
                <Cmd><span>{`net use Z: \\\\${shareResult.address}\\${shareResult.share_name} /user:${shareResult.smb_user} ${shareResult.smb_pass}`}</span>
                  <button onClick={() => copyText(`net use Z: \\\\${shareResult.address}\\${shareResult.share_name} /user:${shareResult.smb_user} ${shareResult.smb_pass}`)}><Copy size={14} /></button></Cmd>
                <div style={{ fontSize: ".82rem", color: "#475569", margin: ".4rem 0 .3rem" }}>Linux/Mac:</div>
                <Cmd><span>{`sudo mount -t cifs //${shareResult.address}/${shareResult.share_name} /mnt/${shareResult.share_name} -o username=${shareResult.smb_user},password=${shareResult.smb_pass}`}</span>
                  <button onClick={() => copyText(`sudo mount -t cifs //${shareResult.address}/${shareResult.share_name} /mnt/${shareResult.share_name} -o username=${shareResult.smb_user},password=${shareResult.smb_pass}`)}><Copy size={14} /></button></Cmd>
              </div>
            )}

            {shares.length === 0 ? <Empty style={{ padding: ".8rem" }}>아직 공유가 없습니다.</Empty> : shares.map(s => (
              <Row key={s.share_id} cols="1.2fr 1.6fr 1fr auto">
                <span style={{ fontWeight: 600, color: "#1e293b" }}>{s.share_name}</span>
                <Mono>{s.path}</Mono>
                <Mono style={{ color: "#64748b" }}>\\{s.address}\{s.share_name}</Mono>
                <span style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
                  <IconBtn onClick={() => copyText(`net use Z: \\\\${s.address}\\${s.share_name} /user:${s.smb_user} ${s.smb_pass}`)} title="마운트 명령 복사"><Copy size={13} /></IconBtn>
                  <IconBtn style={{ borderColor: "#fecaca", color: "#ef4444" }} onClick={() => delShare(s.share_id)}><Trash2 size={13} /></IconBtn>
                </span>
              </Row>
            ))}
          </div>
        </Card>
      )}
    </>
  )
}

/* ── 클라우드 블록 볼륨 ── */
function BlockPanel() {
  const [conns, setConns] = useState([])
  const [adding, setAdding] = useState(false)
  const [busy, setBusy] = useState("")
  const [form, setForm] = useState({ provider: "iwinv", name: "", api_key: "", api_secret: "", region: "" })
  const [vols, setVols] = useState({})

  const load = async () => { try { const d = await fetch(`${API}/block/connections`, { headers: authHeaders(false), credentials: "include" }).then(x => x.json()); setConns(d.connections || []) } catch (_) {} }
  useEffect(() => { load() }, [])

  const add = async () => {
    if (!form.name) { alert("이름 필수"); return }
    setBusy("add")
    try { const res = await fetch(`${API}/block/connections`, { method: "POST", headers: authHeaders(), credentials: "include", body: JSON.stringify(form) }); if (!res.ok) { alert("등록 실패"); return } setForm({ provider: "iwinv", name: "", api_key: "", api_secret: "", region: "" }); setAdding(false); load() } finally { setBusy("") }
  }
  const del = async (id) => { if (!window.confirm("연결을 삭제할까요?")) return; await fetch(`${API}/block/connections/${id}`, { method: "DELETE", headers: authHeaders(false), credentials: "include" }); load() }
  const listVols = async (id) => { const d = await fetch(`${API}/block/connections/${id}/volumes`, { headers: authHeaders(false), credentials: "include" }).then(x => x.json()); setVols(v => ({ ...v, [id]: d })) }

  return (
    <>
      <Note>
        <Cloud size={18} style={{ flexShrink: 0 }} />
        <span>iwinv 등 클라우드의 <strong>블록 스토리지(볼륨)</strong>를 API 자격으로 연결해 참조합니다. 자격을 등록하면 볼륨 목록을 조회합니다.</span>
      </Note>
      <Card>
        <CardHead><span><Database size={16} /> 블록 볼륨 연결 ({conns.length})</span><IconBtn onClick={() => setAdding(v => !v)}><Plus size={13} /> 연결 추가</IconBtn></CardHead>
        {adding && (
          <Form>
            <Select value={form.provider} onChange={e => setForm({ ...form, provider: e.target.value })}><option value="iwinv">iwinv</option><option value="aws">AWS EBS</option><option value="other">기타</option></Select>
            <Input placeholder="이름" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
            <Input placeholder="API Key" value={form.api_key} onChange={e => setForm({ ...form, api_key: e.target.value })} />
            <Input placeholder="API Secret" type="password" value={form.api_secret} onChange={e => setForm({ ...form, api_secret: e.target.value })} />
            <Input placeholder="리전(선택)" value={form.region} onChange={e => setForm({ ...form, region: e.target.value })} style={{ width: 120 }} />
            <Button primary onClick={add} disabled={busy === "add"}>등록</Button>
          </Form>
        )}
        {conns.length === 0 ? <Empty>등록된 블록 볼륨 연결이 없습니다.</Empty> : conns.map(c => (
          <div key={c.conn_id}>
            <Row cols="1.2fr 1fr 1fr auto">
              <span style={{ fontWeight: 600, color: "#1e293b" }}>{c.name}</span>
              <span style={{ color: "#64748b" }}>{c.provider}{c.region ? ` · ${c.region}` : ""}</span>
              <span style={{ color: "#475569", fontSize: ".82rem" }}><Dot s={c.last_status === "ok" ? "ok" : c.last_status === "fail" ? "fail" : ""} />{c.last_status || "pending"}</span>
              <span style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
                <IconBtn onClick={() => listVols(c.conn_id)}><ChevronRight size={13} /> 볼륨 조회</IconBtn>
                <IconBtn style={{ borderColor: "#fecaca", color: "#ef4444" }} onClick={() => del(c.conn_id)}><Trash2 size={13} /></IconBtn>
              </span>
            </Row>
            {vols[c.conn_id] && (
              <div style={{ padding: ".4rem 1.5rem 1rem", color: "#94a3b8", fontSize: ".82rem" }}>
                {vols[c.conn_id].pending ? `※ ${vols[c.conn_id].note}` :
                  (vols[c.conn_id].volumes || []).length === 0 ? "볼륨이 없습니다." :
                    (vols[c.conn_id].volumes || []).map((v, i) => <div key={i}><Mono>{v.id} — {fmtBytes(v.size)} — {v.status}</Mono></div>)}
              </div>
            )}
          </div>
        ))}
      </Card>
    </>
  )
}

/* ── 사용 가이드 ── */
const GStepWrap = styled.div`margin-bottom:1.1rem;`
const GStepTitle = styled.div`display:flex; align-items:center; gap:.55rem; font-weight:700; color:#1e293b; font-size:.92rem; margin-bottom:.4rem;
  .n{display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:50%;background:var(--accent);color:#fff;font-size:.78rem;flex-shrink:0;}`
const GStepBody = styled.div`padding-left:1.85rem; color:#475569; font-size:.87rem; line-height:1.65; b{color:#1e293b;} ul{margin:.3rem 0;padding-left:1.1rem;} li{margin:.18rem 0;}`
function GStep({ n, t, children }) {
  return <GStepWrap><GStepTitle><span className="n">{n}</span>{t}</GStepTitle><GStepBody>{children}</GStepBody></GStepWrap>
}
function GCmd({ children }) { return <Cmd><span>{children}</span><button onClick={() => copyText(children)} title="복사"><Copy size={14} /></button></Cmd> }

function StorageGuide() {
  return (
    <>
      <Note><Network size={18} style={{ flexShrink: 0 }} />
        <span>온프레 박스를 <strong>SkynetMesh VPC</strong>에 연결한 뒤, 디스크를 네트워크 드라이브로 공유하거나 클라우드 블록 볼륨을 참조합니다.</span>
      </Note>

      <Card>
        <CardHead><span><HardDrive size={16} /> 네트워크 드라이브 (온프레) 사용법</span></CardHead>
        <div style={{ padding: "1.2rem 1.5rem" }}>
          <GStep n="1" t="온프레 박스를 VPC에 연결">
            <b>네트워크</b> 화면에서 VPC 생성 → 가입 토큰 발급 → 박스에 에이전트 설치(가상IP 부여):
            <GCmd>irm https://skynet.re.kr/download/install.ps1 | iex</GCmd>
            <GCmd>curl -fsSL https://skynet.re.kr/download/install.sh | sudo bash</GCmd>
          </GStep>
          <GStep n="2" t="스토리지 노드 등록">
            <b>네트워크 드라이브</b> 탭 → <b>노드 추가</b> → 가상IP, SSH 계정/개인키(또는 비밀번호).
          </GStep>
          <GStep n="3" t="디스크 확인 & 공유 만들기">
            노드의 <b>관리</b> → 디스크(lsblk) 확인 → <b>공유 만들기</b>에 공유 이름·경로(예: <Mono>/mnt/disk1</Mono>) 입력.
            SSH로 Samba가 자동 구성되고 전용 계정/비밀번호가 발급됩니다.
          </GStep>
          <GStep n="4" t="내 PC에서 마운트">
            <div style={{ fontWeight: 600, color: "#334155", margin: ".2rem 0" }}>Windows</div>
            <GCmd>{`net use Z: \\\\<가상IP>\\<공유명> /user:<계정> <비밀번호>`}</GCmd>
            <div style={{ fontWeight: 600, color: "#334155", margin: ".4rem 0 .2rem" }}>Linux / Mac</div>
            <GCmd>{`sudo mount -t cifs //<가상IP>/<공유명> /mnt/<공유명> -o username=<계정>,password=<비밀번호>`}</GCmd>
          </GStep>
        </div>
      </Card>

      <Card>
        <CardHead><span><Cloud size={16} /> 블록 볼륨 (클라우드) 사용법</span></CardHead>
        <div style={{ padding: "1.2rem 1.5rem" }}>
          <GStep n="1" t="연결 등록">
            <b>블록 볼륨</b> 탭 → <b>연결 추가</b> → 프로바이더(iwinv 등) 선택 + API Key / Secret + 리전 입력.
          </GStep>
          <GStep n="2" t="볼륨 조회">
            등록한 연결의 <b>볼륨 조회</b>로 클라우드 블록 볼륨 목록을 참조합니다. (프로바이더 API 연동)
          </GStep>
        </div>
      </Card>
    </>
  )
}

/* ── 에이전트 기반(자동): VPC 호스트의 디스크가 SSH 없이 자동으로 보임 ── */
function AgentPanel() {
  const [agents, setAgents] = useState([])
  const [sel, setSel] = useState(null)
  const [blocks, setBlocks] = useState([])
  const [diskInfo, setDiskInfo] = useState({ online: true, raw: null, os: null })
  const [shares, setShares] = useState([])
  const [busy, setBusy] = useState("")
  const [shareForm, setShareForm] = useState({ share_name: "", path: "" })
  const [shareResult, setShareResult] = useState(null)

  const load = async () => {
    try { const d = await fetch(`${API}/agents`, { headers: authHeaders(false), credentials: "include" }).then(x => x.json()); setAgents(d.agents || []) } catch (_) {}
  }
  useEffect(() => { load() }, [])

  const openHost = async (a) => {
    setSel(a); setBlocks([]); setShares([]); setShareResult(null); setDiskInfo({ online: true, raw: null, os: a.os_type }); setBusy("open")
    try {
      const [b, s] = await Promise.all([
        fetch(`${API}/agents/${a.address}/disks`, { headers: authHeaders(false), credentials: "include" }).then(x => x.json()),
        fetch(`${API}/agents/${a.address}/shares`, { headers: authHeaders(false), credentials: "include" }).then(x => x.json()),
      ])
      setBlocks(b.devices || []); setDiskInfo({ online: b.online, raw: b.raw, os: b.os }); setShares(s.shares || [])
    } catch (_) { setDiskInfo({ online: false, raw: "조회 실패", os: a.os_type }) } finally { setBusy("") }
  }

  const createShare = async () => {
    if (!shareForm.share_name || !shareForm.path) { alert("공유이름·경로 필수"); return }
    setBusy("share")
    try {
      const res = await fetch(`${API}/agents/${sel.address}/shares`, { method: "POST", headers: authHeaders(), credentials: "include", body: JSON.stringify(shareForm) })
      const d = await res.json().catch(() => ({}))
      if (!res.ok) { alert("공유 생성 실패:\n" + (d.error || res.status)); return }
      setShareResult(d); setShareForm({ share_name: "", path: "" }); openHost(sel); load()
    } finally { setBusy("") }
  }
  const delShare = async (sid) => { if (!window.confirm("공유를 삭제할까요?")) return; await fetch(`${API}/agents/${sel.address}/shares/${sid}`, { method: "DELETE", headers: authHeaders(false), credentials: "include" }); openHost(sel); load() }

  const flatBlocks = []
  const walk = (d, depth) => { (d || []).forEach((x) => { flatBlocks.push({ ...x, depth }); if (x.children) walk(x.children, depth + 1) }) }
  walk(blocks, 0)
  const winPath = (diskInfo.os || sel?.os_type) === "windows"

  return (
    <>
      <Note>
        <Network size={18} style={{ flexShrink: 0 }} />
        <span><strong>SkynetMesh 에이전트</strong>만 깔린 VPC 호스트면 <strong>SSH·비밀번호·방화벽 설정 없이</strong> 디스크가 자동으로 보입니다.
          호스트에서 폴더를 골라 <strong>네트워크 드라이브</strong>로 공유하세요.</span>
      </Note>

      <Card>
        <CardHead>
          <span><Server size={16} /> VPC 호스트 ({agents.length})</span>
          <IconBtn onClick={load}><RefreshCw size={13} /> 새로고침</IconBtn>
        </CardHead>
        {agents.length === 0 ? (
          <Empty>
            VPC에 연결된 호스트가 없습니다.
            <div style={{ marginTop: ".6rem", fontSize: ".82rem", color: "#64748b" }}>
              호스트에서 SkynetMesh 에이전트를 설치/연결하면 여기에 자동으로 나타납니다. (네트워크 메뉴 참고)
            </div>
          </Empty>
        ) : agents.map(a => (
          <Row key={a.address} cols="1.3fr 1.3fr .9fr .9fr auto">
            <span style={{ fontWeight: 600, color: "#1e293b", display: "flex", alignItems: "center", gap: 6 }}><HardDrive size={15} color="#64748b" /> {a.name || a.address}</span>
            <Mono>{a.address}</Mono>
            <span>{a.os_type && <span style={{ fontSize: ".72rem", padding: "1px 7px", borderRadius: 10, background: a.os_type === "windows" ? "#dbeafe" : "#dcfce7", color: a.os_type === "windows" ? "#1d4ed8" : "#15803d" }}>{a.os_type}</span>}</span>
            <span style={{ color: "#64748b", fontSize: ".82rem" }}>공유 {a.share_count}</span>
            <span style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
              <IconBtn onClick={() => openHost(a)} disabled={busy === "open"} title="디스크/공유 관리"><Settings size={13} /> 관리</IconBtn>
            </span>
          </Row>
        ))}
      </Card>

      {sel && (
        <Card>
          <CardHead>
            <span><Settings size={16} /> {sel.name || sel.address} — 디스크 & 공유</span>
            <IconBtn onClick={() => setSel(null)}><X size={13} /> 닫기</IconBtn>
          </CardHead>
          <div style={{ padding: "1rem 1.5rem" }}>
            <div style={{ fontWeight: 600, color: "#475569", fontSize: ".85rem", marginBottom: ".5rem" }}>디스크</div>
            {flatBlocks.length === 0 ? (
              <Empty style={{ padding: ".8rem" }}>
                {busy === "open" ? "조회 중…" : diskInfo.online === false
                  ? "에이전트 응답 없음 — 호스트에서 SkynetMesh 에이전트가 실행 중인지 확인하세요."
                  : "디스크가 없습니다."}
              </Empty>
            ) : (
              <div style={{ border: "1px solid #f1f5f9", borderRadius: 8, overflow: "hidden" }}>
                <Row cols="2fr .8fr .8fr 1fr 1.2fr" style={{ background: "#f8fafc", fontWeight: 600, color: "#64748b", fontSize: ".8rem" }}>
                  <span>이름</span><span>크기</span><span>타입</span><span>파일시스템</span><span>마운트</span>
                </Row>
                {flatBlocks.map((b, i) => (
                  <Row key={i} cols="2fr .8fr .8fr 1fr 1.2fr">
                    <Mono style={{ paddingLeft: b.depth * 14 }}>{b.depth > 0 ? "└ " : ""}{b.name}{b.model ? ` (${b.model.trim()})` : ""}</Mono>
                    <span style={{ fontSize: ".82rem" }}>{fmtBytes(b.size)}</span>
                    <span style={{ fontSize: ".82rem", color: "#64748b" }}>{b.type}</span>
                    <span style={{ fontSize: ".82rem", color: "#64748b" }}>{b.fstype || "-"}</span>
                    <Mono style={{ color: b.mountpoint ? "#16a34a" : "#cbd5e1" }}>{b.mountpoint || "-"}</Mono>
                  </Row>
                ))}
              </div>
            )}

            <div style={{ fontWeight: 600, color: "#475569", fontSize: ".85rem", margin: "1.2rem 0 .5rem" }}>네트워크 드라이브 공유</div>
            <div style={{ display: "flex", gap: ".5rem", flexWrap: "wrap", alignItems: "center", marginBottom: ".7rem" }}>
              <Input placeholder="공유 이름 (예: data)" value={shareForm.share_name} onChange={e => setShareForm({ ...shareForm, share_name: e.target.value })} style={{ width: 180 }} />
              <Input placeholder={winPath ? "공유할 경로 (예: D:\\data)" : "공유할 경로 (예: /mnt/disk1)"} value={shareForm.path} onChange={e => setShareForm({ ...shareForm, path: e.target.value })} style={{ flex: 1, minWidth: 200 }} />
              <Button primary onClick={createShare} disabled={busy === "share"}><FolderPlus size={15} /> {busy === "share" ? "구성 중…" : "공유 만들기"}</Button>
            </div>

            {shareResult && (
              <div style={{ background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 8, padding: "1rem", marginBottom: ".7rem" }}>
                <div style={{ fontWeight: 600, color: "#166534", marginBottom: ".4rem" }}>공유 생성됨 — 내 PC에서 연결</div>
                <Cmd><span>{`net use Z: \\\\${shareResult.address}\\${shareResult.share_name} /user:${shareResult.smb_user} ${shareResult.smb_pass}`}</span>
                  <button onClick={() => copyText(`net use Z: \\\\${shareResult.address}\\${shareResult.share_name} /user:${shareResult.smb_user} ${shareResult.smb_pass}`)}><Copy size={14} /></button></Cmd>
              </div>
            )}

            {shares.length === 0 ? <Empty style={{ padding: ".8rem" }}>아직 공유가 없습니다.</Empty> : shares.map(s => (
              <Row key={s.share_id} cols="1.2fr 1.6fr 1fr auto">
                <span style={{ fontWeight: 600, color: "#1e293b" }}>{s.share_name}</span>
                <Mono>{s.path}</Mono>
                <Mono style={{ color: "#64748b" }}>\\{sel.address}\{s.share_name}</Mono>
                <span style={{ display: "flex", gap: 6, justifyContent: "flex-end" }}>
                  <IconBtn onClick={() => copyText(`net use Z: \\\\${sel.address}\\${s.share_name} /user:${s.smb_user} ${s.smb_pass}`)} title="마운트 명령 복사"><Copy size={13} /></IconBtn>
                  <IconBtn style={{ borderColor: "#fecaca", color: "#ef4444" }} onClick={() => delShare(s.share_id)}><Trash2 size={13} /></IconBtn>
                </span>
              </Row>
            ))}
          </div>
        </Card>
      )}
    </>
  )
}

const MyStorage = () => {
  const [tab, setTab] = useState("agent")
  return (
    <Page>
      <Header>
        <div>
          <Title>스토리지</Title>
          <Sub>VPC 호스트의 디스크를 네트워크 드라이브로 공유하고, 클라우드 블록 볼륨을 참조합니다.</Sub>
        </div>
      </Header>
      <Content>
        <NodeSetupGuide section="storage"/>
        <TabBar>
          <TabBtn active={tab === "agent"} onClick={() => setTab("agent")}><HardDrive size={15} /> 네트워크 드라이브 (자동)</TabBtn>
          <TabBtn active={tab === "onprem"} onClick={() => setTab("onprem")}><KeyRound size={15} /> SSH 직접연결 (고급)</TabBtn>
          <TabBtn active={tab === "block"} onClick={() => setTab("block")}><Cloud size={15} /> 블록 볼륨 (클라우드)</TabBtn>
          <TabBtn active={tab === "guide"} onClick={() => setTab("guide")}><BookOpen size={15} /> 사용 가이드</TabBtn>
        </TabBar>
        {tab === "agent" ? <AgentPanel /> : tab === "onprem" ? <OnPremPanel /> : tab === "block" ? <BlockPanel /> : <StorageGuide />}
      </Content>
    </Page>
  )
}

export default MyStorage
